jQuery($ => {

    // event subscription form
    const eventSubscriptionForm = $('#eventSubscriptionForm');
    eventSubscriptionForm.on('submit', function (e) {
        e.preventDefault();

        $.ajax({
            url: main.ajax_url,
            dataType: 'json',
            method: 'post',
            data: {
                action: "subscribe_event",
                user_id: $('#userID').val(),
                event_id: $('#eventID').val(),
            },
            beforeSend: function() {
                $('.eventPopup .dot-spin').show();
                $('.eventPopup #eventAccept').addClass('btn-disabled');
            },
            complete: function() {
                $('.eventPopup .dot-spin').hide();
                $('.eventPopup #eventAccept').removeClass('btn-disabled');
            },
            error: function() {
                $('.eventPopup .m-popup__title').text('Upps!');
                $('.eventPopup .m-popup__desc').text('Wystąpił jakiś błąd przy próbie zapisu. Spróbuj ponownie później.');
            },
            success: function(res) {
                console.log(res.status);
                $('.eventPopup .m-popup__title').text('Dziękujemy!');
                $('.eventPopup .m-popup__desc').text('Zostałeś pomyślnie zapisany na wydarzenie.');
                $('#eventAccept').remove();
                $('.eventPopup .e-button--secondary').text('Zamknij');
                if ($('.popupOpen.eventBtn').length > 0) {
                    $('.popupOpen.eventBtn').addClass('btn-disabled');
                    $('.popupOpen.eventBtn').text('Jesteś już zapisany na te wydarzenie');
                }
            }
        });
    });

    const jobOfferDropDown = $("#jobOfferDropDown");
    const workofferDropDown = $("#workofferDropDown");

    let paged = 2;
    let finish = false;

    // AJAX display joboffer
    function displayjoboffer(term_id, change) {
        const employjoboffer = $(".m-employ__wrapper");
        const jobofferLoader = $(".jobofferLoader");

        $.ajax({
            url: main.ajax_url,
            type: 'post',
            data: {
                action:     'load_joboffer',
                term_id:    term_id,
                paged: paged
            },
            beforeSend: function() {
                employjoboffer.addClass('m-employ__wrapper--loading');
                jobofferLoader.show();
            },
            complete: function() {
                employjoboffer.removeClass('m-employ__wrapper--loading');
                jobofferLoader.hide();
            },
            success: function(res) {
                if (change) {
                    employjoboffer.children().remove();
                }

                if (! res) {
                    finish = true;
                }
                employjoboffer.append(res);
                paged++;
            },
        });
    }

    jobOfferDropDown.on("change", function() {
        var selectedValue = get_term_id($(this));
        paged = 1;

        displayjoboffer(selectedValue, true);
    });

    function get_term_id(dropdown) {
        const items = dropdown.find(".e-select__items");
        const selected = items.find(".current");
        return selected.attr("value");
    }

    if (jobOfferDropDown.length) {
        $(window).on('scroll', _.throttle(updatePosition, 3000));

        function updatePosition() {
            if (finish) {
                return;
            }
            var a = $(".m-employ__wrapper").offset().top;
            var b = $(".m-employ__wrapper").height();
            var c = $(window).height();
            var d = $(window).scrollTop();
            if ((c+d)>(a+b)) {
                displayjoboffer(get_term_id(jobOfferDropDown), false);
            }
        }
    }

    // AJAX display looking for job offers
    function displayworkoffer(term_id) {
        const employjoboffer = $(".m-employ__wrapper");
        const jobofferLoader = $(".jobofferLoader");

        $.ajax({
            url: main.ajax_url,
            type: "post",
            data: {
                action: "load_workoffer",
                term_id: term_id
            },
            beforeSend: function() {
                jobofferLoader.show();
            },
            complete: function() {
                jobofferLoader.hide();
            },
            success: function(res) {
                employjoboffer.children().remove();
                employjoboffer.append(res);
            }
        });
    }

    workofferDropDown.on("change", function() {
        const items = $(this).find(".e-select__items");
        const selected = items.find(".current");
        const selectedValue = selected.attr("value");

        displayworkoffer(selectedValue);
    });

    // ajax form : register
    const registerInfo = $(".registerPopup .m-popup__error");
    const registerBtn = $("form#registerForm .e-button");
    const registerLoader = $('.registerLoader');
    const registerForm = $('form#registerForm');

    registerForm.on("submit", function(e) {
        e.preventDefault();

        registerInfo.hide();

        $.ajax({
            url: main.ajax_url,
            type: "post",
            dataType: "json",
            data: {
                action: "ajaxregister",
                serialized: $(this).serialize()
            },
            beforeSend: function() {
                registerBtn.addClass('active');
                registerLoader.show();
            },
            complete: function() {
                registerBtn.removeClass('active');
                registerLoader.hide();
            },
            success: function(res) {
                registerInfo.show().text(res.message);
                if (res.registered == true) {
                    registerInfo.addClass('success');
                    registerForm[0].reset();

                    window.setTimeout(function() {
                        $(".m-popup__close").trigger("click");
                        registerInfo.hide();
                    }, 2000);
                }
            }
        });
    });

    const phoneInput = $("#numberValidate");

    phoneInput.find("input").attr("data-validation", "number");

    $.validate({
        modules: "html5",
        form: "#registerForm",
        validateOnBlur: true,
        borderColorOnError: "",
        scrollToTopOnError: false
    });

    // $.validate({
    //     ignore: ["acf[field_5e25c21543cfe]"],
    //     modules: "html5,logic, sanitize",
    //     form: "#new-smalloffers",
    //     validateOnBlur: true,
    //     borderColorOnError: "",
    //     scrollToTopOnError: false
    // });

    // AJAX - get account number
    const duesBtn = $("#duesForm");
    const duesResult = $("#duesResult");
    const duesLoader = $('#duesLoader');

    duesBtn.on("submit", function(e) {
        e.preventDefault();

        $.ajax({
            url: "https://www.dilnet.wroc.pl/ikb/ikb.php",
            headers: { origin: "dilnet.wroc.pl" },
            data: $(this).serialize(),
            type: "GET",
            beforeSend: function() {
                duesLoader.show();
                duesResult.empty();
            },
            complete: function() {
                duesLoader.hide();
            },
            success: function(res) {
                if (res.indexOf("Nr konta:") >= 0) {
                    res = res.replace('Nr konta: ', '');
                    duesResult.prepend('<p><strong>Twój indywidulany nr konta to:</strong></p>');
                }
                duesResult.append(res);
            }
        });
    });

});
